// extracted by mini-css-extract-plugin
module.exports = {"counter":"counter_counter__NUfAw","counter__button":"counter_counter__button__dLvv4","counter__count":"counter_counter__count__qPouI"};